import { Provider, Root } from '@radix-ui/react-tooltip'
import type { ComponentProps, JSX } from 'react'

export type TooltipProps = ComponentProps<typeof Root>

export function Tooltip({
  delayDuration = 100,
  ...delegated
}: TooltipProps): JSX.Element {
  return (
    <Provider>
      <Root delayDuration={delayDuration} {...delegated} />
    </Provider>
  )
}
